import { apiPost, getHostApi, getHostUrl } from './apiWrapper';
import { isNullOrUndefined } from './storeFunctions';
import { formatDate } from 'react-day-picker/moment';

const LOCATION_CHANGE = '@@router/LOCATION_CHANGE'; // hardcoded to save 9KB lib link just to get one value
const alertsRequest = "ALERTS_REQUEST";
const alertsSuccess = "ALERTS_SUCCESS";
const alertsError = "ALERTS_ERROR";
const alertsFilterSet = "ALERTS_FILTER_SET";
const filterSet = "FILTER_SET";
const alertsSetSeen = "ALERTS_SET_SEEN";
const alertsEditNotes = "ALERTS_EDIT_NOTES";
const alertsFilterReset = "ALERTS_FILTER_RESET";
const alertsSetError = "ALERTS_SET_ERROR";
const exportFailure = "ALERTS_EXPORT_FAILURE";

export const monthsAgo = (n) => daysAgo(Math.round(365 / 12 * n));

export const daysAgo = (n) => {
    var d = new Date();
    d.setDate(d.getDate() - n);
    return formatDate(d, 'YYYY-MM-DD', 'cs');
}

const filterState = {
    portfolios: [],
    orderCol: null,
    orderDesc: false,
    count: 30,
    offset: 0,
    notifiedFrom: monthsAgo(1),
    createdFrom: daysAgo(90)
}

const initialState = {
    isLoading: false,
    data: null,
    error: null,
    filter: { ...filterState }
};

export const alertsActions = {
    getAlerts: () => async (dispatch, getState) => _getAlerts(dispatch, getState),
    setAlertsFilter: (key, data) => async (dispatch) => { dispatch({ type: alertsFilterSet, key: key, data: data }); return Promise.resolve(); },
    setFilter: (data) => async (dispatch, getState) => parseFilter(data, dispatch, getState),
    setSeen: (index, seen) => async (dispatch) => dispatch({ type: alertsSetSeen, index, seen }),
    editNotes: (index, noteId) => async (dispatch) => dispatch({ type: alertsEditNotes, index, noteId }),
    resetSearchFilters: () => async (dispatch, getState) => { dispatch({ type: alertsFilterReset }); _getAlerts(dispatch, getState); },
    setAlertsError: (e) => async (dispatch) => dispatch({ type: alertsError, error: e }),
    exportAlerts: () => async (dispatch, getState) => _exportAlerts(dispatch, getState),
    exportAlertsCsv: () => async (dispatch, getState) => _exportAlertsCsv(dispatch, getState),
};

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case LOCATION_CHANGE:
            return { ...state, location: action.payload.pathname };
        case alertsRequest:
            return {
                ...state, isLoading: true, error: null
            };
        case alertsSuccess:
            return {
                ...state,
                data: action.data, isLoading: false, error: null
            };
        //case exportFailure:
        case alertsError:
            return { ...state, data: null, isLoading: false, error: isNullOrUndefined(action.error) ? null :
                { exception: action.error.exception, exceptionData: isNullOrUndefined(action.error.exceptionData) ? undefined : action.error.exceptionData } }
        case alertsSetSeen:
            var alerts = state.data.alerts
            alerts[action.index].seen = action.seen;
            return { ...state, data: { ...state.data, alerts: alerts, unseen: action.seen ? state.data.unseen - 1 : state.data.unseen + 1 } }
        case alertsEditNotes:
            var alerts = state.data.alerts
            alerts[action.index].noteId = action.noteId;
            return { ...state, data: { ...state.data, alerts: alerts} }
        case alertsFilterSet:
            return { ...state, filter: { ...state.filter, [action.key]: action.data } }
        case alertsFilterReset:
            return { ...state, filter: { ...filterState } }
        case filterSet:
            return { ...state, filter: action.filter }
        default:
            return state;
    };
};

function parseToInt(value) {
    if (isNullOrUndefined(value) || value === "")
        return 0;
    return parseInt(value);
}


function parseToDate(value) {
    if (isNullOrUndefined(value) || value === "" || value.length === 0)
        return null;
    return value[0];
}

function testValue(value) {
    if (isNullOrUndefined(value) || value === "")
        return false;
    else
        return true;
}

function parseFilter(data, dispatch, getState) {
    var filter = {};
    var oldFilter = getState().alerts.filter;
    filter.portfolios = oldFilter.portfolios;
    filter.orderCol = oldFilter.orderCol;
    filter.orderDesc = oldFilter.orderDesc;
    filter.count = oldFilter.count;
    filter.offset = 0;
    filter.showAll = data.showAll;
    if (testValue(data.dob))
        filter.dob = parseToDate(data.dob);
    if (testValue(data.regionId))
        filter.regionId = parseToInt(data.regionId);
    if (testValue(data.districtId))
        filter.districtId = parseToInt(data.districtId);
    if (testValue(data.municipalityId))
        filter.municipalityId = parseToInt(data.municipalityId);
    if (testValue(data.cadastreUnitId))
        filter.cadastreUnitId = parseToInt(data.cadastreUnitId);
    if (testValue(data.docNo))
        filter.docNo = parseToInt(data.docNo);
    if (testValue(data.createdFrom))
        filter.createdFrom = parseToDate(data.createdFrom);
    if (testValue(data.createdTo))
        filter.createdTo = parseToDate(data.createdTo);
    if (testValue(data.notifiedFrom))
        filter.notifiedFrom = parseToDate(data.notifiedFrom);
    if (testValue(data.notifiedTo))
        filter.notifiedTo = parseToDate(data.notifiedTo);
    if (testValue(data.fullName))
        filter.fullName = data.fullName;
    if (testValue(data.ico))
        filter.ico = data.ico;
    if (testValue(data.rc))
        filter.rc = data.rc;
    if (testValue(data.events))
        filter.events = data.events;
    dispatch({ type: filterSet, filter });
    _getAlerts(dispatch, getState);
}

function _getAlerts(dispatch, getState) {
    dispatch({ type: alertsRequest });
    apiPost(
        `${getHostApi()}/api/portfolio/alerts/search`, undefined,
        getState().alerts.filter,
        (s) => {
            if (s.data.isSuccess)
                dispatch({ type: alertsSuccess, data: s.data });
            else
                dispatch({ type: alertsError, error: { exception: s.data.exception, exceptionData: s.data.exceptionData } })
        },
        (e) => dispatch({ type: alertsError, error: { exception: e } })
    )
}

function _exportAlerts(dispatch, getState) {
    const state = getState();
    apiPost(
        `${getHostApi()}/api/portfolio/alerts/export`, undefined,
        getState().alerts.filter,
        (s) => {
            if (!s || !s.data || s.error)
                dispatch({ type: exportFailure, error: { exception: s.error } })
        },
        (e) => dispatch({ type: exportFailure, error: { exception: e } })
    )
}

function _exportAlertsCsv(dispatch, getState) {
    apiPost(
        `${getHostApi()}/api/portfolio/alerts/export-csv`, undefined,
        getState().alerts.filter,
        (s) => {
            if (!s || !s.data || s.error)
                dispatch({ type: exportFailure, error: { exception: s.error } })
        },
        (e) => dispatch({ type: exportFailure, error: { exception: e } })
    )
}

function _downloadExport(userContext, fileId) {
    const url = `${getHostUrl()}/files/portfolio/bulk/${fileId}`;
    if (window !== undefined)
        window.location = url;
}
